import { Outlet } from "react-router-dom";

function Utils() {
	return (
		<div className="utils__container">
			<div className="utils__header"></div>
			<Outlet />
		</div>
	);
}

export default Utils;
